"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumeric = void 0;
const assertString_1 = require("./util/assertString");
const alpha_1 = require("./alpha");
const numericNoSymbols = /^[0-9]+$/;
function isNumeric(str, options) {
    (0, assertString_1.assertString)(str);
    if (options && options.no_symbols) {
        return numericNoSymbols.test(str);
    }
    return (new RegExp(`^[+-]?([0-9]*[${(options === null || options === void 0 ? void 0 : options.locale) ? alpha_1.decimal[options.locale] : '.'}])?[0-9]+$`)).test(str);
}
exports.isNumeric = isNumeric;
